import Vue from 'vue';
import Vuex from 'vuex';
import api from '../API';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    UserBtnPermissionsData: [] // 按钮权限
  },
  mutations: {
    logout (state, vm) {
      state.user = null;
    },
    SET_BTN_PERMISSIONS (state, data) {
      state.UserBtnPermissionsData = data;
    },
    setUser (state, data) {
      state.user = data;
    }
  },
  actions: {
    getUser ({ commit, state }) {
      let pre = new Promise((resolve, reject) => {
        if (state.user != null && state.user !== '') {
          resolve(state.user);
        } else {
          api.getCurUser().then((res) => {
            let json = res.data;
            if (json.status === '200') {
              state.user = json.data;
              resolve(state.user);
            } else if (json.status === '403') {
              window.location.href = '/403';
            } else {
              state.user = null;
              resolve(state.user);
            }
          }).catch((e) => {
            state.user = null;
            resolve(state.user);
          });
        }
      });

      return pre;
    },
    GET_BTN_PERMISSIONS ({ commit, state }, path) {
      let pre = new Promise((resolve, reject) => {
        api.getUserBtnPermissions().then((res) => {
          let json = res.data;
          if (json.status === '200') {
            json.data.forEach(item => {
              if (item.route === 'LC_MU_Label_project_registration') {
                commit('SET_BTN_PERMISSIONS', item.btnSet);
              }
            });
          }
          resolve(state.UserBtnPermissionsData);
        }).catch(err => {
          reject(err);
        });
      });
      return pre;
    }
  }
});
